import React, { Fragment } from 'react'

// components
// import Header from '../Header/header'
import Footer from '../../components/Footer'
import { Helmet } from 'react-helmet'

// styles
import '../../scss/base.scss'
import '../../scss/plugins/bootstrap.scss'
import '../../fonts/Catamaran/Catamaran.css'
import '../../fonts/Roboto/Roboto.css'

const Layout = ({ children }) => {
  return (
    <Fragment>
      <Helmet>
        <script>
          {`
            (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:2753445,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `}
        </script>
      </Helmet>
      <main>
        { children }
      </main>
      <Footer />
    </Fragment>
  )
}

export default Layout
